import { APP_FBCLID, APP_FBCLID_AT } from '@common/constants';

export interface IMetaParams {
  fbp?: string;
  fbc?: string;
  fbclid?: string;
  fbclidAt?: number;
  sourceUrl?: string;
}

function readStorage(key: string): string {
  try {
    return window.localStorage.getItem(key) ?? '';
  } catch {
    return '';
  }
}

function writeStorage(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    return;
  }
}

function readCookies(): string {
  try {
    return document.cookie ?? '';
  } catch {
    return '';
  }
}

export function readCookie(cookies: string, name: string): string {
  const prefix = `${name}=`;
  const found = cookies.split(';').map((part) => part.trim()).find((part) => part.startsWith(prefix));
  if (!found) {
    return '';
  }
  const value = found.slice(prefix.length).trim();
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

export function readFbclid(searchParams: URLSearchParams): string {
  return (searchParams.get('fbclid') ?? '').trim();
}

export function storeFbclid(searchParams: URLSearchParams, now: number = Date.now()): void {
  const fbclid = readFbclid(searchParams);
  if (fbclid) {
    if (readStorage(APP_FBCLID) !== fbclid || !readStorage(APP_FBCLID_AT)) {
      writeStorage(APP_FBCLID_AT, String(now));
    }
    writeStorage(APP_FBCLID, fbclid);
  }
}

export function readClickTime(value: string): number | undefined {
  const time = Number(value);
  return Number.isInteger(time) && time > 0 ? time : undefined;
}

export function buildMetaParams(cookies: string, fbclid: string, fbclidAt = '', sourceUrl = ''): IMetaParams | null {
  const meta: IMetaParams = {};
  const fbp = readCookie(cookies, '_fbp');
  const fbc = readCookie(cookies, '_fbc');
  const clickId = fbclid.trim();
  const clickTime = clickId ? readClickTime(fbclidAt) : undefined;
  if (fbp) {
    meta.fbp = fbp;
  }
  if (fbc) {
    meta.fbc = fbc;
  }
  if (clickId) {
    meta.fbclid = clickId;
  }
  if (clickTime) {
    meta.fbclidAt = clickTime;
  }
  if (sourceUrl) {
    meta.sourceUrl = sourceUrl;
  }
  return Object.keys(meta).length ? meta : null;
}

function currentPage(): string {
  try {
    return window.location.href;
  } catch {
    return '';
  }
}

export function getMetaParams(): IMetaParams | null {
  return buildMetaParams(readCookies(), readStorage(APP_FBCLID), readStorage(APP_FBCLID_AT), currentPage());
}
